import React from 'react';
import { map, parseInt, keys, capitalize, toLower } from 'lodash';
import {
  SingleHeader,
  MultiHeader,
  MultiDataColumn,
  SingleDataColumn
} from '../components';
import { convertISOToDateFormat } from '../../../util/timezone';
import { normalizeAlertScore } from '../../../util/normalization';
import { FRAUD_PREVENTION_SOURCE_IDS } from '../../constants/commonConstants';

const preventionAlertColors = (key, fraudActions) => {
  return fraudActions?.find(
    ({ displayName }) => toLower(displayName) === toLower(key)
  )?.alertLevelColor;
};

export default [
  {
    title: 'Alert',
    children: [
      {
        title: <MultiHeader header="Alert ID" subHeaders={['Alert Date']} />,
        width: '15%',
        ellipsis: true,
        render: (_, record) => {
          const { alertId = '-', alertDate = '-' } = record;
          return (
            <MultiDataColumn.Link
              pop
              data={[
                { text: alertId },
                { text: convertISOToDateFormat(alertDate) }
              ]}
              customLink="/app/cm/alerts/:alertId"
              customLinkParam=":alertId"
              newTab={true}
            />
          );
        }
      }
    ]
  },
  {
    title: 'Alert',
    align: 'left',
    children: [
      {
        title: <SingleHeader header="Alert Source" />,
        width: '15%',
        render: (_, record) => {
          const { alertSourceName = '-' } = record;
          return <SingleDataColumn>{alertSourceName}</SingleDataColumn>;
        }
      },
      {
        title: (
          <MultiHeader header="Alert Level" subHeaders={['Alert Score']} />
        ),
        width: '10%',
        render: (_, record) => {
          const {
            alertLevel = '',
            alertLevelLabel,
            alertLevelColor,
            alertScore = 0,
            additionalFraudInfo = {},
            alertSourceId,
            fraudActions
          } = record;

          if (FRAUD_PREVENTION_SOURCE_IDS.includes(parseInt(alertSourceId))) {
            return keys(additionalFraudInfo)?.map((key) => (
              <div
                style={{
                  marginBottom: 4,
                  color: preventionAlertColors(key, fraudActions)
                }}>{`${key}: ${additionalFraudInfo[key]}`}</div>
            ));
          } else {
            const value = normalizeAlertScore(Number(alertScore).toFixed(2));

            return (
              <div title={normalizeAlertScore(alertScore)}>
                <SingleDataColumn.ProgressBar
                  value={value}
                  level={alertLevelLabel || capitalize(alertLevel)}
                  strokeColor={alertLevelColor}
                />
              </div>
            );
          }
        }
      }
    ]
  },
  {
    title: 'Account',
    children: [
      {
        title: (
          <MultiHeader
            header="Account Number"
            subHeaders={['Account Currency']}
          />
        ),
        width: '10%',
        render: (_, record) => {
          const { accountId = '-', accountCurrency = '-' } = record;
          return (
            <MultiDataColumn
              data={[{ text: accountId }, { text: accountCurrency }]}
            />
          );
        }
      }
    ]
  },
  {
    title: 'Business Segment',
    width: '12%',
    children: [
      {
        title: '',
        render: (_, record) => {
          const { segmentName = '-' } = record;
          return <SingleDataColumn>{segmentName}</SingleDataColumn>;
        }
      }
    ]
  },
  {
    title: 'Typologies triggered',
    children: [
      {
        title: '',
        width: '28%',
        ellipsis: true,
        render: (_, record) => {
          const {
            alertSourceId,
            triggeredTypologies = [],
            triggeredRules = []
          } = record;
          return (
            <SingleDataColumn.Ellipsis
              pop
              value={
                FRAUD_PREVENTION_SOURCE_IDS.includes(parseInt(alertSourceId))
                  ? map(triggeredRules, 'ruleName').join(', ')
                  : map(triggeredTypologies, 'name').join(', ')
              }
            />
          );
        }
      }
    ]
  },
  {
    title: 'Alert Status',
    children: [
      {
        title: <MultiHeader header="Status" subHeaders={['Close Date']} />,
        width: '10%',
        render: (_, record) => {
          const { alertStatus = '-', closureDate = '-' } = record;
          return (
            <MultiDataColumn
              data={[
                { text: alertStatus },
                { text: convertISOToDateFormat(closureDate) }
              ]}
            />
          );
        }
      }
    ]
  }
];
